
import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/vue";
import { defineComponent, ref, watch } from "vue";
import { defineRule, Field } from "vee-validate";
import { required, one_of as oneOf } from "@vee-validate/rules";

import GenderRepository from "@/composables/GenderRepository";
import { useI18n } from "vue-i18n";

defineRule('required', required);
defineRule('oneOf', oneOf);

export default defineComponent({
  components: {
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    Field
  },
  props: {
    modelValue: [ Number, String ],
    label: {
      type: String,
      default: "Seleccione un Genero",
    },
    required: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const { genders } = GenderRepository();
    const val = ref(props.modelValue)
    const oneOf = ref<(number | string)[]>([]);

    watch(genders, () => {
      oneOf.value = Array.from(genders.value.map((gender) => gender.id))
    })

    const setSelectedGender = (event: CustomEvent) => {
      emit("update:modelValue", event.detail.value)
    }
    return {
      t,
      oneOf,
      val,
      genders,
      setSelectedGender
    };
  },
});
